import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AcademyHeader from '../../../components/LP/AcademyHeader';
import LPFooter from '../../../components/LP/LPFooter';
import LPFAQ from '../../../components/LP/LPFAQ';
import SEO from '../../../components/SEO/SEO';

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

const faqItems = [
  {
    question: '開業したばかりでも参加できますか？',
    answer: 'はい、参加できます。開業3年の事例でも月額15万円の契約を獲得した実績があります。早い段階でコンサルの型を身につける方が、長期的に有利です。',
  },
  {
    question: '経営数字や財務が苦手でも大丈夫ですか？',
    answer: '大丈夫です。難しい会計知識は必要ありません。経営数字を社労士視点で使えるよう、実例を交えながら一緒に学んでいきます。SrWithシステムが数字の可視化をサポートします。',
  },
  {
    question: '営業が苦手ですが、コンサル契約は取れますか？',
    answer: '「売り込まない営業」の型を学びます。入口は既存顧問先への「小さな相談」で構いません。事例のほとんどが「解雇相談」「労務相談」などよくある相談からスタートしています。',
  },
  {
    question: 'システム継続の月額は必須ですか？',
    answer: '任意です。継続を希望しない場合は前月末日までにご連絡いただければ、翌月末日に解約となります。',
  },
];


const AcademyDetailLP = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col font-noto bg-lp-cream text-lp-charcoal">
      <SEO
        title="SrWithアカデミー｜社労士のためのコンサル6ヶ月プログラム"
        description="学ぶだけで終わらせない。実践・継続まで伴走する6ヶ月のプログラムで、再現できるコンサルの型を手に入れます。"
      />

      <AcademyHeader />

      <main className="flex-grow pt-[48px]">
      {/* ─── HERO SECTION ─── */}
      <section className="relative bg-lp-charcoal overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-black/30 to-transparent" />
        <div className="relative max-w-[860px] mx-auto px-5 pt-20 pb-24 md:pt-20 md:pb-32 text-center">
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {['Zoom・オンライン', '6ヶ月プログラム', '社労士専門', '時間単価5万円を目指す'].map((tag) => (
              <span
                key={tag}
                className="inline-block px-4 py-1.5 text-xs font-medium tracking-wide rounded-full bg-white/10 text-white/80 border border-white/20"
              >
                {tag}
              </span>
            ))}
          </div>
          <h1 className="font-noto-serif text-3xl md:text-5xl lg:text-[3.25rem] leading-tight font-bold text-white mb-6">
            6ヶ月で、コンサルを「仕組み」にする。
          </h1>
          <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-[640px] mx-auto mb-10">
            学ぶだけで終わらせない。実践・継続まで伴走する6ヶ月のプログラムで、再現できるコンサルの型を手に入れます。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => scrollTo('price')}
              className="px-8 py-4 bg-lp-rose text-white font-medium rounded-lg hover:opacity-90 transition-opacity text-sm md:text-base"
            >
              料金・申し込みを見る
            </button>
            <button
              onClick={() => scrollTo('cta')}
              className="px-8 py-4 border border-white text-white font-medium rounded-lg hover:bg-white/10 transition-colors text-sm md:text-base"
            >
              まず無料相談する
            </button>
          </div>
        </div>
      </section>

      {/* ─── FOR WHO SECTION ─── */}
      <section id="for-who" className="bg-lp-cream">
        <div className="max-w-[860px] mx-auto px-5 py-20 md:py-24">
          <h2 className="font-noto-serif text-2xl md:text-3xl font-bold text-center text-lp-charcoal mb-12">
            こんな社労士に向いています
          </h2>
          <div className="space-y-4">
            {[
              '手続き業務が中心で、単価が上がらないと感じている',
              '経営者に「もっと深く関わりたい」が、どうすれば良いかわからない',
              'コンサル提案に興味はあるが、営業が苦手で踏み出せない',
              'AI・SaaSの台頭に危機感があり、差別化を考えている',
              '「再現性のある仕組み」を作って、安定した収益を築きたい',
              '同じ志を持つ社労士仲間と切磋琢磨したい',
            ].map((item) => (
              <div key={item} className="flex items-start gap-4 bg-white rounded-xl px-6 py-5 border border-lp-border">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-lp-rose flex items-center justify-center mt-0.5">
                  <svg className="w-3.5 h-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span className="text-sm md:text-base text-lp-charcoal leading-relaxed">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── OUTCOME SECTION ─── */}
      <section className="bg-white">
        <div className="max-w-[860px] mx-auto px-5 py-20 md:py-24">
          <h2 className="font-noto-serif text-2xl md:text-3xl font-bold text-center text-lp-charcoal mb-12">
            6ヶ月後に手に入るもの
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                kanji: '型',
                subtitle: 'コンサルの流れ',
                desc: 'ヒアリング・提案・成約・継続まで、再現できるコンサルの流れが身につきます。',
              },
              {
                kanji: '言',
                subtitle: '経営者との共通言語',
                desc: '経営数字・人件費マネジメントの言語で経営者と対話できます。',
              },
              {
                kanji: '仕',
                subtitle: '継続収益モデル',
                desc: '月3.5万円×複数社の積み上げモデルで、安定した高単価収益を実現します。',
              },
            ].map((card) => (
              <div
                key={card.kanji}
                className="text-center bg-lp-rose-pale rounded-2xl px-6 py-10 border border-lp-rose-light"
              >
                <span className="font-noto-serif text-5xl md:text-6xl text-lp-rose font-bold leading-none">
                  {card.kanji}
                </span>
                <h3 className="font-noto-serif text-lg font-bold text-lp-charcoal mt-5 mb-3">
                  {card.subtitle}
                </h3>
                <p className="text-sm text-lp-charcoal-mid leading-relaxed">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── ROADMAP SECTION ─── */}
      <section className="bg-lp-gray">
        <div className="max-w-[860px] mx-auto px-5 py-20 md:py-24">
          <h2 className="font-noto-serif text-2xl md:text-3xl font-bold text-center text-lp-charcoal mb-4">
            6ヶ月のロードマップ
          </h2>
          <p className="text-center text-sm md:text-base text-lp-charcoal-mid leading-relaxed mb-14 max-w-[640px] mx-auto">
            「学び」→「実践」→「仕組み化」の3フェーズで、確実にコンサルを実現します。
          </p>

          <div className="space-y-10">
            {/* Phase 1 */}
            <div className="border-l-4 border-lp-rose pl-6 md:pl-8">
              <div className="flex items-center gap-3 mb-1">
                <span className="inline-block px-3 py-1 text-xs font-bold text-white bg-lp-rose rounded-full">
                  PHASE 1
                </span>
                <span className="text-sm text-lp-charcoal-mid font-medium">1〜2ヶ月目</span>
              </div>
              <h3 className="font-noto-serif text-lg md:text-xl font-bold text-lp-charcoal mb-4">
                学び・設計 ── 目標と土台をつくる
              </h3>
              <ul className="space-y-2">
                {[
                  '社労士コンサルとしてのあり方構築',
                  '理想の事務所設計・売上シミュレーション',
                  '3.5万円モデル構築',
                  'どんな会社でも使える人件費マネジメントの基礎',
                  '自分に合った営業法の選択',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm md:text-base text-lp-charcoal-mid">
                    <span className="text-lp-rose mt-1 flex-shrink-0">●</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Phase 2 */}
            <div className="border-l-4 border-lp-rose-mid pl-6 md:pl-8">
              <div className="flex items-center gap-3 mb-1">
                <span className="inline-block px-3 py-1 text-xs font-bold text-white bg-lp-rose-mid rounded-full">
                  PHASE 2
                </span>
                <span className="text-sm text-lp-charcoal-mid font-medium">2〜5ヶ月目</span>
              </div>
              <h3 className="font-noto-serif text-lg md:text-xl font-bold text-lp-charcoal mb-4">
                実践 ── 契約を生む動きへ
              </h3>
              <ul className="space-y-2">
                {[
                  '理念策定・パーフェクトカスタマーの設定',
                  '行動計画の作成・営業活動・ロープレ',
                  '提案書・見積書の作成と添削',
                  'コーチング学習（ヒアリング力・思考整理）',
                  'コンサル力アップ・営業動線の整理',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm md:text-base text-lp-charcoal-mid">
                    <span className="text-lp-rose-mid mt-1 flex-shrink-0">●</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Phase 3 */}
            <div className="border-l-4 border-lp-rose pl-6 md:pl-8">
              <div className="flex items-center gap-3 mb-1">
                <span className="inline-block px-3 py-1 text-xs font-bold text-white bg-lp-rose rounded-full">
                  PHASE 3
                </span>
                <span className="text-sm text-lp-charcoal-mid font-medium">6ヶ月目</span>
              </div>
              <h3 className="font-noto-serif text-lg md:text-xl font-bold text-lp-charcoal mb-4">
                継続 ── 再現できる状態へ
              </h3>
              <ul className="space-y-2">
                {[
                  '半年間の振り返りと面談設計のブラッシュアップ',
                  '事例共有と改善',
                  '今後の顧客獲得戦略の策定',
                  '再現できる仕組みの完成',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm md:text-base text-lp-charcoal-mid">
                    <span className="text-lp-rose mt-1 flex-shrink-0">●</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ─── SUPPORT SECTION ─── */}
      <section className="bg-white">
        <div className="max-w-[860px] mx-auto px-5 py-20 md:py-24">
          <h2 className="font-noto-serif text-2xl md:text-3xl font-bold text-center text-lp-charcoal mb-12">
            充実したサポート体制
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                icon: '\uD83C\uDFAC',
                title: '動画コンテンツ',
                desc: '社労士としてのあり方・営業法・経営数字の読み方・コンサル手法・SrWithシステム活用法など。いつでも何度でも視聴可能。',
              },
              {
                icon: '\uD83D\uDCAC',
                title: 'グループセッション',
                desc: '成果報告・提案書の実践添削・営業戦略の具体相談・事例共有。セッション外でも常時相談可能。',
              },
              {
                icon: '\uD83D\uDCDA',
                title: '月次勉強会（2種）',
                desc: '「コンサル勉強会」と「営業勉強会」を月1回ずつ開催。アーカイブあり・参加自由。',
              },
              {
                icon: '\uD83E\uDD1D',
                title: 'パートナーコミュニティ',
                desc: '全国のSrWithパートナー社労士と繋がれるコミュニティ。継続参加可能。',
              },
            ].map((card) => (
              <div key={card.title} className="bg-lp-rose-pale rounded-2xl px-5 py-8 text-center border border-lp-rose-light">
                <div className="text-4xl mb-4">{card.icon}</div>
                <h3 className="font-noto-serif text-base font-bold text-lp-charcoal mb-3">{card.title}</h3>
                <p className="text-sm text-lp-charcoal-mid leading-relaxed">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── PRICE SECTION ─── */}
      <section id="price" className="bg-lp-charcoal text-white">
        <div className="max-w-[860px] mx-auto px-5 py-20 md:py-24">
          <h2 className="font-noto-serif text-2xl md:text-3xl font-bold text-center mb-4">
            料金と回収ロジック
          </h2>
          <p className="text-center text-sm md:text-base text-white/70 leading-relaxed mb-12 max-w-[640px] mx-auto">
            月3.5万円のコンサル契約を1社獲得すれば、受講料を回収できる設計になっています。
          </p>

          {/* Price box */}
          <div className="bg-white/10 rounded-2xl p-8 md:p-10 mb-8">
            <h3 className="font-noto-serif text-lg md:text-xl font-bold text-center mb-8">
              アカデミー＋システム 6ヶ月でコンサルを仕組みにするプログラム
            </h3>
            <div className="grid md:grid-cols-2 gap-8 md:gap-12">
              {/* Left: Price */}
              <div className="text-center md:text-left">
                <div className="font-noto-serif text-4xl md:text-5xl font-bold tracking-tight">¥300,000</div>
                <p className="text-white/70 text-sm mt-2">(税込 330,000円)</p>
                <p className="text-white/60 text-xs mt-3">契約締結後14日以内に一括振込</p>
              </div>
              {/* Right: Included */}
              <div>
                <ul className="space-y-3">
                  {[
                    'アカデミー受講（6ヶ月フルサポート）',
                    'SrWithシステムの利用（6ヶ月）',
                    'グループセッション',
                    '動画コンテンツ（全編・永続視聴）',
                    '月次勉強会×2種（アーカイブあり）',
                    'パートナーコミュニティ参加',
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm">
                      <svg className="w-5 h-5 text-lp-rose-mid flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="text-center mt-10">
              <a
                href="https://timerex.net/s/shotsu923_b21b/84385a85"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-10 py-4 bg-lp-rose text-white font-medium rounded-lg hover:opacity-90 transition-opacity text-sm md:text-base"
              >
                申し込み・個別相談はこちら
              </a>
            </div>
          </div>

          <p className="text-center text-sm text-white/70 mb-1">
            月額 ¥19,800（税抜）でシステム＋コミュニティを継続
          </p>
          <p className="text-center text-xs text-white/50">
            解約通知があるまで自動継続。前月末日までの通知で翌月末解約。
          </p>

          {/* ROI section */}
          <div className="mt-16 grid md:grid-cols-5 gap-4 items-center">
            <div className="bg-white/10 rounded-xl p-6 text-center md:col-span-1">
              <div className="font-noto-serif text-base font-bold mb-2">1社：月3.5万円のコンサル契約</div>
              <p className="text-xs text-white/60 leading-relaxed">既存顧問先・紹介から始める。売り込まない関わり方で。</p>
            </div>
            <div className="hidden md:flex items-center justify-center text-2xl text-white/40">→</div>
            <div className="bg-white/10 rounded-xl p-6 text-center md:col-span-1">
              <div className="font-noto-serif text-base font-bold mb-2">12ヶ月で投資回収</div>
              <p className="text-xs text-white/60 leading-relaxed">35,000円×12ヶ月＝420,000円。受講料330,000円を上回る。</p>
            </div>
            <div className="hidden md:flex items-center justify-center text-2xl text-white/40">→</div>
            <div className="bg-white/10 rounded-xl p-6 text-center md:col-span-1">
              <div className="font-noto-serif text-base font-bold mb-2">積上げ：毎月+1社で拡大</div>
              <p className="text-xs text-white/60 leading-relaxed">3年後に月105万円（30社×3.5万円）を目指す。</p>
            </div>
          </div>
        </div>
      </section>

      {/* ─── CASES SECTION ─── */}
      <section id="cases" className="bg-lp-cream">
        <div className="max-w-[860px] mx-auto px-5 py-20 md:py-24">
          <h2 className="font-noto-serif text-2xl md:text-3xl font-bold text-center text-lp-charcoal mb-4">
            導入事例
          </h2>
          <p className="text-center text-sm md:text-base text-lp-charcoal-mid leading-relaxed mb-12 max-w-[640px] mx-auto">
            入口は「よくある相談」。課題整理から提案・成約へ──共通する構造があります。
          </p>
          <div className="grid md:grid-cols-2 gap-6">
            {/* Case 1 */}
            <div className="bg-white rounded-2xl border border-lp-border overflow-hidden">
              <div className="px-6 pt-6 pb-2">
                <span className="text-xs text-lp-charcoal-light font-medium">佐賀県・開業18年</span>
                <h3 className="font-noto-serif text-lg font-bold text-lp-charcoal mt-2 mb-4">
                  解雇相談から、月額10万円の経営伴走へ
                </h3>
                <ul className="space-y-2 mb-5">
                  {[
                    '化粧品検査業（40名）の解雇相談が入口',
                    '適正人員数・人件費・賞与算出を提案',
                    '月1回1〜2時間の現場セッションコンサルへ',
                    'その他 月3.5〜5万円のセッション型コンサル×複数社',
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm text-lp-charcoal-mid">
                      <span className="text-lp-rose mt-0.5 flex-shrink-0">・</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="px-6 pb-6">
                <span className="inline-block px-4 py-2 bg-lp-rose-pale text-lp-rose text-sm font-bold rounded-lg border border-lp-rose-light">
                  月額10万円の顧問契約を獲得
                </span>
              </div>
            </div>

            {/* Case 2 */}
            <div className="bg-white rounded-2xl border border-lp-border overflow-hidden">
              <div className="px-6 pt-6 pb-2">
                <span className="text-xs text-lp-charcoal-light font-medium">佐賀県・開業3年</span>
                <h3 className="font-noto-serif text-lg font-bold text-lp-charcoal mt-2 mb-4">
                  税理士紹介から、月額15万円の経営伴走へ
                </h3>
                <ul className="space-y-2 mb-5">
                  {[
                    '税理士からの労務＋給与紹介が入口',
                    '社長ビジョン整理・キャッシュフロー設計まで対応',
                    '月1回2〜3時間の現場セッションコンサルへ',
                    '建設業（6名）で月額15万円の顧問契約も獲得',
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm text-lp-charcoal-mid">
                      <span className="text-lp-rose mt-0.5 flex-shrink-0">・</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="px-6 pb-6">
                <span className="inline-block px-4 py-2 bg-lp-rose-pale text-lp-rose text-sm font-bold rounded-lg border border-lp-rose-light">
                  月額9.5万円＋15万円の複数契約を実現
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── FAQ SECTION ─── */}
      <section className="bg-white">
        <div className="max-w-[860px] mx-auto px-5 py-20 md:py-24">
          <h2 className="font-noto-serif text-2xl md:text-3xl font-bold text-center text-lp-charcoal mb-12">
            よくある質問
          </h2>
          <LPFAQ items={faqItems} accentColor="lp-rose" />
        </div>
      </section>

      {/* ─── CTA SECTION ─── */}
      <section id="cta" className="bg-lp-charcoal py-20">
        <div className="max-w-[860px] mx-auto px-5 text-center">
          <h2 className="font-noto-serif text-2xl md:text-3xl font-bold text-white mb-4">
            まず、個別相談から始めませんか。
          </h2>
          <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-[540px] mx-auto mb-10">
            「自分の事務所でも実現できるか？」あなたの状況に合わせて、一緒に考えます。押し売りは一切ありません。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://timerex.net/s/shotsu923_b21b/84385a85"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 bg-lp-rose text-white font-medium rounded-lg hover:opacity-90 transition-opacity text-sm md:text-base"
            >
              個別相談を予約する（無料）
            </a>
            <Link
              to="/lp/academy/seminar"
              className="inline-block px-8 py-4 border border-white text-white font-medium rounded-lg hover:bg-white/10 transition-colors text-sm md:text-base"
            >
              まず無料セミナーに参加する
            </Link>
          </div>
        </div>
      </section>
      </main>
      <LPFooter />
    </div>
  );
};

export default AcademyDetailLP;
